import { Button, Icon, Input, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { DataCard } from "../common/cards";
import { useFake } from "../../hooks";
import { useAssistance } from "../../plugin/hooks";
import AssistanceCard from "../dashboard/AssistanceCard";
import NoCallIcon from "../../plugin/components/common/icons/NoCallIcon";
import PhoneOn from "../../plugin/components/common/icons/PhoneOn";

const IncomingCallCard = (props) => {
  const { t } = useTranslation();
  const { isCalling } = useFake();
  const { assistance } = useAssistance();

  return isCalling ? (
    <AssistanceCard assistance={assistance} readOnly />
  ) : (
    <DataCard
      backgroundColor={"transparent"}
      boxShadow={"none"}
      borderStyle={"dashed"}
      borderWidth={"2px"}
      borderColor={"#B8BCBD"}
      {...props}>
      <VStack>
        <Text color={"#B8BCBD"} fontWeight={400} fontSize={"14px"} marginTop={"48px"}>
          <Trans>
            {isCalling ? "operator.calls.call" : "operator.calls.noCall"}
          </Trans>
        </Text>
        <Icon as={NoCallIcon} width={"40px"} height={"40px"} color={"#B8BCBD"} />
        <Input marginTop={"24px"} color={"black"} borderColor={"#B8BCBD"} _placeholder={{color: "#B8BCBD"}} backgroundColor={"white"} size={"md"} borderRadius={"10px"} placeholder={t("operator.calls.placeholder")}></Input>
        <Button
          variant={"ghost"}
          borderWidth={1}
          borderColor={"#B8BCBD"}
          backgroundColor={"white"}
          color={"#B8BCBD"}
          verticalAlign={"baseline"}
          width={"50px"}
          marginTop={"24px"}
          height={"50px"}>
          <Icon as={PhoneOn} boxSize={"15px"} />
        </Button>
      </VStack>
    </DataCard >
  );
};

export default React.memo(IncomingCallCard);
